var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_989_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_189_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_190_",
    d: "M22.31,11.09H3.69C2.76,11.09,2,10.33,2,9.4V2.97c0-0.93,0.76-1.69,1.69-1.69h18.62 c0.93,0,1.69,0.76,1.69,1.69V9.4C24,10.33,23.24,11.09,22.31,11.09z M3.69,2.97V9.4h18.62l0-6.43H3.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_184_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_185_",
    d: "M22.31,24.72H3.69C2.76,24.72,2,23.96,2,23.03v-6.62c0-0.93,0.76-1.69,1.69-1.69h18.62 c0.93,0,1.69,0.76,1.69,1.69v6.62C24,23.96,23.24,24.72,22.31,24.72z M3.69,16.42v6.62h18.62l0-6.62H3.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_183_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_389_",
    d: "M19.43,7.19H6.35c-0.57,0-1.04-0.47-1.04-1.04v0c0-0.57,0.47-1.04,1.04-1.04h13.08 c0.57,0,1.04,0.47,1.04,1.04v0C20.47,6.72,20.01,7.19,19.43,7.19z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_182_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_388_",
    d: "M19.43,20.76H6.35c-0.57,0-1.04-0.47-1.04-1.04v0c0-0.57,0.47-1.04,1.04-1.04h13.08 c0.57,0,1.04,0.47,1.04,1.04v0C20.47,20.3,20.01,20.76,19.43,20.76z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonGroup);
export default __webpack_public_path__ + "static/media/ButtonGroup.2dd9cfe6bc8aff0f3715b1dd927ab825.svg";
export { ForwardRef as ReactComponent };